function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 152.4 108"
    },
    viewBox: "0 0 152.4 108"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h152.4v108H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4 25.7h31.5v56.6H60.4z",
    style: {
      fill: "#ff5f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4 54c0-11 5.1-21.5 13.7-28.3-15.6-12.3-38.3-9.6-50.6 6.1C13.3 47.4 16 70 31.7 82.3c13.1 10.3 31.4 10.3 44.5 0C67.5 75.5 62.4 65 62.4 54",
    style: {
      fill: "#eb001b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.4 54c0 19.9-16.1 36-36 36-8.1 0-15.9-2.7-22.2-7.7 15.6-12.3 18.3-34.9 6-50.6-1.8-2.2-3.8-4.3-6-6 15.6-12.3 38.3-9.6 50.5 6.1 5 6.3 7.7 14.1 7.7 22.2",
    style: {
      fill: "#f79e1b"
    }
  }));
};
export { SvgMastercard as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI3LjkuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxNTIuNCAxMDgiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDE1Mi40IDEwODsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOm5vbmU7fQoJLnN0MXtmaWxsOiNGRjVGMDA7fQoJLnN0MntmaWxsOiNFQjAwMUI7fQoJLnN0M3tmaWxsOiNGNzlFMUI7fQo8L3N0eWxlPgo8Zz4KCTxyZWN0IHk9IjAiIGNsYXNzPSJzdDAiIHdpZHRoPSIxNTIuNCIgaGVpZ2h0PSIxMDgiLz4KCTxnPgoJCTxyZWN0IHg9IjYwLjQiIHk9IjI1LjciIGNsYXNzPSJzdDEiIHdpZHRoPSIzMS41IiBoZWlnaHQ9IjU2LjYiLz4KCQk8cGF0aCBjbGFzcz0ic3QyIiBkPSJNNjIuNCw1NGMwLTExLDUuMS0yMS41LDEzLjctMjguM2MtMTUuNi0xMi4zLTM4LjMtOS42LTUwLjYsNi4xQzEzLjMsNDcuNCwxNiw3MCwzMS43LDgyLjMKCQkJYzEzLjEsMTAuMywzMS40LDEwLjMsNDQuNSwwQzY3LjUsNzUuNSw2Mi40LDY1LDYyLjQsNTR6Ii8+CgkJPHBhdGggY2xhc3M9InN0MyIgZD0iTTEzNC40LDU0YzAsMTkuOS0xNi4xLDM2LTM2LDM2Yy04LjEsMC0xNS45LTIuNy0yMi4yLTcuN2MxNS42LTEyLjMsMTguMy0zNC45LDYtNTAuNmMtMS44LTIuMi0zLjgtNC4zLTYtNgoJCQljMTUuNi0xMi4zLDM4LjMtOS42LDUwLjUsNi4xQzEzMS43LDM4LjEsMTM0LjQsNDUuOSwxMzQuNCw1NHoiLz4KCTwvZz4KPC9nPgo8L3N2Zz4K";